import {date as formatDate} from '@management-ui/core';
import {styled} from '@mui/styles';
import React from 'react';

const Holder = styled('span')(({theme}) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),

  '& span': {
    background: theme.palette.grey['100'],
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
  },

  '&.unconfirmed': {
    '& > span': {
      background: theme.palette.warning.light,
      color: theme.palette.warning.contrastText,
    },

    '& > strong': {
      color: theme.palette.warning.main,
    }
  },

  '&.confirmed': {
    '& > span': {
      background: theme.palette.success.light,
      color: theme.palette.success.contrastText,
    },

    '& > strong': {
      color: theme.palette.success.main,
    }
  },
}));

const ConfirmedDate = ({date, confirmed, showLabel = true}) => (
  <Holder {...(date && confirmed ? {className: 'confirmed'} : date && !confirmed ? {className: 'unconfirmed'} : {})}>
    {date ? (<>
      <span>{formatDate(date)}</span>
      {showLabel ? <strong>{confirmed ? 'Confirmed' : 'Unconfirmed'}</strong> : null}
    </>) : '-'}
  </Holder>
)

export default ConfirmedDate;
